module.exports = __webpack_public_path__ + "media/question2_en.509a72f6.wav";